import { useTranslations } from '@vocab/react';
import {
  Actions,
  Box,
  Heading,
  Hidden,
  Stack,
  Text,
} from 'braid-design-system';

import { ButtonLink } from 'src/components/Link/Link';
import { links } from 'src/links';
import {
  seekBlueLight700,
  seekBlueLight800,
  seekRaspberryPink700,
} from 'src/theme';

import translations from '../.vocab';

import * as styles from './Banners.css.ts';

export const FooterBanner = () => {
  const { t } = useTranslations(translations);

  return (
    <Box
      marginY={['medium', 'medium', 'xxlarge']}
      position="relative"
      style={{ background: seekBlueLight800 }}
      background="customDark"
      borderRadius="large"
      paddingY={['large', 'large', 'xxlarge']}
      paddingX={['large', 'large', 'xxlarge']}
      overflow="hidden"
    >
      <Box paddingX={['large', 'large', 'xxxlarge']}>
        <Stack space="large" align="center">
          <Heading level="3" weight="weak" align="center">
            {t('linkSeekToYourATS')}
          </Heading>
          <Text size="standard" align="center" weight="regular" tone="neutral">
            {t('selectYourATSDescription')}
          </Text>
          <Text size="standard" align="center" weight="regular" tone="neutral">
            {t('completeForm')}
          </Text>
          <Actions>
            {
              <>
                <ButtonLink
                  variant="ghost"
                  tone="neutral"
                  href={links.LINK_YOUR_SOFTWARE.path}
                  tracking={links.LINK_YOUR_SOFTWARE.tracking}
                >
                  {t('linkYourATS')}
                </ButtonLink>
              </>
            }
          </Actions>
        </Stack>
      </Box>

      <Hidden below="desktop">
        <svg
          width="150"
          height="313"
          viewBox="0 0 150 313"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.bottomRightShape}
        >
          <path
            d="M150 163.743L150 313.743L0 313.743C0 230.9 67.1572 163.743 150 163.743Z"
            fill={seekRaspberryPink700}
          />
          <path
            d="M0 50.7432L-4.37114e-06 0.743168L50 0.743164C50 28.3574 27.6143 50.7432 0 50.7432Z"
            fill={seekBlueLight700}
          />
        </svg>
      </Hidden>
    </Box>
  );
};
